import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import strings from '@/language/Swedish';
import { valueDate } from './indexViewerConfig';
import { ChartSeriesType } from './IndexCompareChart';

const buildRows = (series: ChartSeriesType[]) => {
  const dates = new Set<string>();
  series.forEach((item) =>
    item.values.forEach((value) => dates.add(valueDate(value)))
  );
  const sortedDates = Array.from(dates).sort();

  const valueMaps = series.map(
    (item) =>
      new Map(item.values.map((value) => [valueDate(value), value.value]))
  );

  return {
    header: ['Datum', ...series.map((item) => item.name)],
    rows: sortedDates.map((date) => [
      date,
      ...valueMaps.map((values) => values.get(date) ?? ''),
    ]),
  };
};

const exportIndexSeriesToExcel = async (
  series: ChartSeriesType[],
  fileName: string
) => {
  const { header, rows } = buildRows(series);
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(strings.indexApp.title);

  worksheet.addRow(header);
  rows.forEach((row) => worksheet.addRow(row));

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
};

// Semicolon separator + BOM so the file opens correctly in Excel with Swedish locale
const escapeCsvField = (value: string | number) => {
  const text = String(value);
  return /[;"\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const exportIndexSeriesToCsv = (
  series: ChartSeriesType[],
  fileName: string
) => {
  const { header, rows } = buildRows(series);
  const lines = [
    header.map(escapeCsvField).join(';'),
    ...rows.map((row) => row.map(escapeCsvField).join(';')),
  ];

  const blob = new Blob(['\uFEFF' + lines.join('\r\n')], {
    type: 'text/csv;charset=utf-8',
  });
  saveAs(blob, `${fileName}.csv`);
};

export { exportIndexSeriesToExcel, exportIndexSeriesToCsv };
